// @flow
import type { Element } from 'react';

import React from 'react';
import { Form } from 'reactstrap';
import {
  INCLUDE_COLLAPSE,
  INCLUDE_REPAIR_TIME,
  INCLUDE_PER_REALIZATION_OUTPUT,
  INCLUDE_RESIDUAL_DRIFT,
  INCLUDE_TIME_BASED_ANALYSIS,
  INCLUDE_USRC,
  TRUNCATE_COLLAPSE_DISTRIBUTION,
  TRUNCATE_COLLAPSE_DISTRIBUTION_LEVEL,
  TRUNCATE_COMPONENT_DISTRIBUTION,
  TRUNCATE_COMPONENT_DISTRIBUTION_LEVEL,
  REGION_COST_MULTIPLIER,
  DATE_COST_MULTIPLIER,
  OCCUPANCY_COST_MULTIPLIER,
  COMPONENT_SOFT_COST_MODIFIER,
  NUM_REALIZATIONS,
} from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import {
  Field,
  FormGroup,
  Fieldset,
  FormGroupCol as Col,
} from '#components/pages/Models/Model/support/form/index.js';

type Props = {|
  form: string,
  fieldsByName: Object,
  heading: string,
  onBack: Function,
  onNext: Function,
|};

const AnalysisOptionsSection = (props: Props): Element<'div'> => {
  const { form, fieldsByName, heading, onBack, onNext } = props;

  return (
    <div>
      <h2>{heading}</h2>
      <Form noValidate>
        <Fieldset form={form} fields={[INCLUDE_REPAIR_TIME]}>
          <legend>Upgrade Options</legend>
          <FormGroup form={form} fields={[INCLUDE_REPAIR_TIME]} row>
            <Col lg="4">
              <Field field={fieldsByName[INCLUDE_REPAIR_TIME]} />
            </Col>
          </FormGroup>
        </Fieldset>
        <Fieldset>
          <legend>General Options</legend>
          <FormGroup form={form} fields={[INCLUDE_COLLAPSE]} row>
            <Col lg="6">
              <Field field={fieldsByName[INCLUDE_COLLAPSE]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[INCLUDE_RESIDUAL_DRIFT]} row>
            <Col lg="9">
              <Field field={fieldsByName[INCLUDE_RESIDUAL_DRIFT]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[INCLUDE_USRC]} row>
            <Col lg="6">
              <Field field={fieldsByName[INCLUDE_USRC]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[INCLUDE_TIME_BASED_ANALYSIS]} row>
            <Col lg="6">
              <Field field={fieldsByName[INCLUDE_TIME_BASED_ANALYSIS]} />
            </Col>
          </FormGroup>
        </Fieldset>
        <Fieldset
          form={form}
          fields={[
            NUM_REALIZATIONS,
            INCLUDE_PER_REALIZATION_OUTPUT,
            TRUNCATE_COLLAPSE_DISTRIBUTION,
            TRUNCATE_COLLAPSE_DISTRIBUTION_LEVEL,
            TRUNCATE_COMPONENT_DISTRIBUTION,
            TRUNCATE_COMPONENT_DISTRIBUTION_LEVEL,
          ]}
        >
          <legend>Simulation Options</legend>
          <FormGroup form={form} fields={[NUM_REALIZATIONS]} row>
            <Col lg="4">
              <Field field={fieldsByName[NUM_REALIZATIONS]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[INCLUDE_PER_REALIZATION_OUTPUT]} row>
            <Col lg="4">
              <Field field={fieldsByName[INCLUDE_PER_REALIZATION_OUTPUT]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[TRUNCATE_COLLAPSE_DISTRIBUTION]} row>
            <Col lg="6">
              <Field field={fieldsByName[TRUNCATE_COLLAPSE_DISTRIBUTION]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[TRUNCATE_COLLAPSE_DISTRIBUTION_LEVEL]} row>
            <Col lg="4" className="pl-4">
              <Field field={fieldsByName[TRUNCATE_COLLAPSE_DISTRIBUTION_LEVEL]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[TRUNCATE_COMPONENT_DISTRIBUTION]} row>
            <Col lg="6">
              <Field field={fieldsByName[TRUNCATE_COMPONENT_DISTRIBUTION]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[TRUNCATE_COMPONENT_DISTRIBUTION_LEVEL]} row>
            <Col lg="4" className="pl-4">
              <Field field={fieldsByName[TRUNCATE_COMPONENT_DISTRIBUTION_LEVEL]} />
            </Col>
          </FormGroup>
        </Fieldset>
        <Fieldset>
          <legend>Cost Multipliers</legend>
          <FormGroup form={form} fields={[REGION_COST_MULTIPLIER]} row>
            <Col lg="4">
              <Field field={fieldsByName[REGION_COST_MULTIPLIER]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[DATE_COST_MULTIPLIER]} row>
            <Col lg="4">
              <Field field={fieldsByName[DATE_COST_MULTIPLIER]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[OCCUPANCY_COST_MULTIPLIER]} row>
            <Col lg="4">
              <Field field={fieldsByName[OCCUPANCY_COST_MULTIPLIER]} />
            </Col>
          </FormGroup>
          <FormGroup form={form} fields={[COMPONENT_SOFT_COST_MODIFIER]} row>
            <Col lg="4">
              <Field field={fieldsByName[COMPONENT_SOFT_COST_MODIFIER]} />
            </Col>
          </FormGroup>
        </Fieldset>
        <BackButton onClick={onBack} />
        <NextButton onClick={onNext} />
      </Form>
    </div>
  );
};

export default AnalysisOptionsSection;
